import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';

import { bookingJourneyType } from 'common/constants/booking';

import modal from '~components/modal';
import PayoutOppsViewer from './viewer';

@modal(
  {
    className: 'payout-opps-viewer-modal',
  },
  true,
)
class PayoutOppsViewerContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, id, bookingJourney, bookingReferenceIds, handleCloseModal } = this.props;

    return (
      <div className="payout-opps-viewer">
        <div className="payout-opps-viewer__header">
          {t(
            `cms.referral.payout.opps.modal.title.${
              bookingJourney === bookingJourneyType.MANUAL ? 'opps' : 'order'
            }`,
          )}
          <CloseOutlined className="payout-opps-viewer__close-button" onClick={handleCloseModal} />
        </div>
        <div className="payout-opps-viewer__body">
          <PayoutOppsViewer
            id={id}
            bookingReferenceIds={bookingReferenceIds}
            bookingJourney={bookingJourney}
            onClose={handleCloseModal}
          />
        </div>

        <div></div>
      </div>
    );
  }
}

PayoutOppsViewerContainer.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  bookingReferenceIds: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PayoutOppsViewerContainer.defaultProps = {
  t: () => {},
  id: '',
  bookingReferenceIds: '',
  handleCloseModal: () => {},
};

export default PayoutOppsViewerContainer;
